import { useQuery } from '@tanstack/react-query';
import type { RecommendedTherapistSummary } from '@lighthouse/shared';
import { api } from '../services/api';

export function useRecommendedTherapists(enabled = true, limit = 6) {
  return useQuery<RecommendedTherapistSummary[]>({
    queryKey: ['recommended-therapists', limit],
    queryFn: () => api.get<RecommendedTherapistSummary[]>(`/therapists/recommended?limit=${limit}`),
    enabled,
  });
}
